import { defineMessages } from 'react-intl';

const messages = defineMessages({
  voidLabel: {
    description: 'shipmentDetailsOtherActions.voidLabel',
    defaultMessage: 'Void Label',
    id: 'ftTKMg',
  },
});

export const VoidLabel = {
  translation: messages.voidLabel,

  handler: ({ actions, activeFulfillment }) => {
    const { launchVoidLabelModal } = actions;
    launchVoidLabelModal(activeFulfillment);
  },

  shouldBeShown: ({ activeFulfillment }) => {
    return !!activeFulfillment;
  },
};
